import React, { Fragment } from "react";
import { HomePageBanner } from "./HomePageBanner";
import { Box, Card, Grid2 as Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import { FormTextField } from "../../components/generic/GenericTextFields";
import { contactUsMail } from "../../config/apisauce";
import { useFormik } from "formik";
import { object, string } from "yup";
import { emailValidation } from "../../helpers/genericFormValidations";
import useStore from "../../states/store";
import useNotiStack from "../../hooks/useNotiStack";
import LoadingButton from "@mui/lab/LoadingButton";
import { Head } from "@inertiajs/react";
import { useTheme } from "@emotion/react";
import BannerImg1 from '../../../../public/banners/homepage-banner-v3.png';

const ContactPage = () => {
  const { success } = useNotiStack();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const [{ loaderState }, { openLoader, closeLoader }] = useStore();

  const sendMail = async (params) => {
    openLoader();
    const response = await contactUsMail(params);
    if (response.ok) {
      success('Successfully submitted!');
    }
    closeLoader();
  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape({
      'name': string().trim().required('Name is required'),
      ...emailValidation,
      'subject': string().trim().required('Subject is required'),
      'message': string().trim().required('Message is required'),
    }),
    onSubmit: (values) => sendMail(values)
  });

  return (
    <Fragment>
      <Head>
        <title>Contact Us</title>
        <meta name="description" content="Need to contact WannaCollab? Visit the contact page." />
      </Head>
      <HomePageBanner
        hasBorderRadius={true}
        title={'Contact Us'}
        bannerImage={BannerImg1}
        subTitle={<>Get in touch with our team {isXs && <br></br>} to learn more about {!isXs && <br></br>}WannaCollab!</>}
      />
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box
          sx={{
            padding: { xs: '20px 0', sm: '30px 140px 0px 140px', md: '30px 100px 0px 100px' },
            color: 'text.semiLight',
            width: { xs: '100%', xsm: '100%', mds: '1044px', sm: '1043px', lg: '1308px', xl: '1570px', xxl: '1835px' }
          }}
        >
          <Grid container spacing={5}>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Typography variant="h6" fontWeight={700} mb={3}>Get In Touch</Typography>
              <Typography fontWeight={700}>Email</Typography>
              <Typography sx={{ textDecoration: 'none' }} component="a" href="mailto:Team@wannaCollab.io" color="primary">Team@wannaCollab.io</Typography>
              <Typography fontWeight={700} mt={3}>Location</Typography>
              <Typography>Los Angeles, CA</Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6 }}>
              <Card>
                <Stack gap={2.5}>
                  <FormTextField
                    value={formik?.values?.name}
                    error={Boolean(formik?.errors?.name)}
                    helperText={formik?.errors?.name}
                    handleChange={(value) => formik.setFieldValue('name', value)}
                    label={'Name'}
                    placeholder={'Jane Doe'}
                  />
                  <FormTextField
                    value={formik?.values?.email}
                    error={Boolean(formik?.errors?.email)}
                    helperText={formik?.errors?.email}
                    handleChange={(value) => formik.setFieldValue('email', value)}
                    label={'Email'}
                    placeholder={'example@email.com'}
                  />
                  <FormTextField
                    label={'Subject'}
                    placeholder={'What is this about?'}
                    value={formik?.values?.subject}
                    error={Boolean(formik?.errors?.subject)}
                    helperText={formik?.errors?.subject}
                    handleChange={(value) => formik.setFieldValue('subject', value)}
                  />
                  <FormTextField
                    label={'Message'}
                    multiline={true}
                    rows={4.5}
                    placeholder={'Type your message here'}
                    value={formik?.values?.message}
                    error={Boolean(formik?.errors?.message)}
                    helperText={formik?.errors?.message}
                    handleChange={(value) => formik.setFieldValue('message', value)}
                  />
                </Stack>
                <Box display={'flex'} justifyContent={'flex-end'} mt={2.5}>
                  <LoadingButton
                    onClick={() => formik.handleSubmit()}
                    className="longButton"
                    loading={loaderState}
                    variant="contained"
                    disabled={loaderState}
                  >
                    Send
                  </LoadingButton>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fragment>
  );
};

export default ContactPage;